import { useRouter } from 'next/router';
import { GetStaticPaths, GetStaticProps } from 'next';

// Pages
import Home from '@components/pages/home';

// Helpers
import useI18n, { getLocalePaths } from '@i18n';

import WithRoles, { rolesEnum } from '@HOCs/WithRole';
// Configs
import routes from '@config/routes.json';
import useRefreshToken from '@hooks/useRefreshToken';

import { CustomGetStaticPathsResult, CustomGetStaticPropsResult } from '../../types';

const IndexPageSwitcher: React.FC = () => {
    const isAuth = useRefreshToken();
    const router = useRouter();
    const { locale } = useI18n();

    if (isAuth) {
        router.push(`/${locale}${routes.dashboard}`);
    }

    return <Home />;
};

export const getStaticProps: GetStaticProps = async ({
    params,
}): Promise<CustomGetStaticPropsResult> => {
    return { props: { locale: params?.locale } };
};

export const getStaticPaths: GetStaticPaths = async (): Promise<CustomGetStaticPathsResult> => {
    return { paths: getLocalePaths(), fallback: false };
};

export default WithRoles(IndexPageSwitcher, [rolesEnum.guest]);
